var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"popover",staticClass:"popover"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c('div',{ref:"contentWrapper",staticClass:"content-wrapper",class:{[`position-${_vm.position}`]:true}},[_vm._t("content")],2):_vm._e()]),_c('span',{ref:"triggerWrapper",staticStyle:{"display":"inline-block"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }